import React from "react";
import { Row, Col } from "react-bootstrap";
import { StatusRemarkHistory } from "../types";

// interface RemarkItem {
//     userName: string;
//     initials: string;
//     timestamp: string;
//     status: string;
//     remark: string;
//     avatarBg?: string;
// }

interface StatusRemarksHistoryProps {
  items: StatusRemarkHistory[];
}

const StatusRemarksHistory: React.FC<StatusRemarksHistoryProps> = ({
  items,
}) => {
  const getInitials = (first?: string | null, last?: string | null) => {
    if (!first && !last) return "?";
    return `${first?.[0] || ""}${last?.[0] || ""}`.toUpperCase();
  };

  const getEmployeeName = (
    first?: string | null,
    last?: string | null,
    username?: string | null
  ) => {
    const fullName = `${first || ""} ${last || ""}`.trim();
    return fullName || username || "Unknown";
  };

  const formatDateTime = (iso: string) => {
    const d = new Date(iso);
    return {
      date: d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      time: d.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
  };

  const getStatusColor = (status: string) => {
    const s = status.toLowerCase();
    if (s.includes("progress")) return { bg: "#FEF3C7", color: "#92400E" };
    if (s.includes("lost")) return { bg: "#FEE2E2", color: "#991B1B" };
    if (s.includes("converted")) return { bg: "#CCFBF1", color: "#115E59" };
    return { bg: "#F3F4F6", color: "#374151" };
  };

  const AVATAR_COLORS = [
    "#4F46E5", // indigo
    "#16A34A", // green
    "#DC2626", // red
    "#EA580C", // orange
    "#0D9488", // teal
    "#7C3AED", // violet
    "#2563EB", // blue
    "#9333EA", // purple
  ];

  const getAvatarColor = (userId?: string, username?: string): string => {
    const key = userId || username || "default";

    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
  };

  return (
    <>
      <style>
        {`
      .followup-box {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  background: #fff;
  padding: 12px;
}

/* Scrollable area */
.followup-scroll {
  max-height: 360px; /* ~4 comments */
  overflow-y: auto;
}

/* Card */
.followup-card {
  padding: 12px;
  border-radius: 8px;
  background-color: #f8f9fa;
  margin-bottom: 10px;
}

/* Avatar */
.avatar-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: #fff;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

/* Status badge */
.status-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 20px;
  color: #fff;
}

/* Comment text */
.comment-text {
  font-size: 12px;
  color: #212529;
  line-height: 1.4;
}

/* Scrollbar (optional) */
.followup-scroll::-webkit-scrollbar {
  width: 6px;
}

.followup-scroll::-webkit-scrollbar-thumb {
  background-color: #ced4da;
  border-radius: 10px;
}

      `}
      </style>

      <Col className="mb-3">
        <div className="followup-box">
          <div className="followup-scroll">
            {items.length === 0 && (
              <div className="text-center py-3">
                No status remarks available.
              </div>
            )}

            {items.map((item, index) => {
              const { date, time } = formatDateTime(item.created_at);
              const statusStyle = getStatusColor(item.status);

              return (
                <div className="followup-card" key={index}>
                  <div className="d-flex align-items-start gap-3">
                    {/* Avatar */}
                    <div
                      className="avatar-circle"
                      style={{
                        backgroundColor: getAvatarColor(
                          item.user_id ?? undefined,
                          item.username ?? undefined
                        ),
                      }}
                    >
                      {getInitials(item.first_name, item.last_name)}
                    </div>

                    {/* Content */}
                    <div className="flex-grow-1">
                      <div className="d-flex align-items-center gap-2">
                        <strong>
                          {getEmployeeName(
                            item.first_name,
                            item.last_name,
                            item.username
                          )}
                        </strong>

                        <span
                          className="status-badge"
                          style={{
                            backgroundColor: statusStyle.bg,
                            color: statusStyle.color,
                          }}
                        >
                          {item.status}
                        </span>
                      </div>

                      <small className="text-muted">
                        {date} • {time}
                      </small>
                    </div>
                  </div>

                  {/* Remark */}
                  <div className="mt-2 comment-text">
                    {item.remark ? item.remark : <em>No remark added</em>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Col>
    </>
  );
};

export default StatusRemarksHistory;
